// import React, { useEffect, useState } from "react";
// import { useOutletContext } from "react-router-dom";
// import { Modal, Button, Pagination } from "react-bootstrap";
// import ViewOrderDetails from "./ViewOrderDetails";
// import "./ServitorSite.css";

// const AcceptedOrders = () => {
//   // Retrieve the logged-in servitor data
//   const { servitor } = useOutletContext();

//   const [acceptedOrders, setAcceptedOrders] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [selectedOrder, setSelectedOrder] = useState(null);
//   const [blockedModal, setBlockedModal] = useState(false);
//   const [currentPage, setCurrentPage] = useState(1);
//   const ordersPerPage = 10;

//   useEffect(() => {
//     if (servitor && servitor.Id) {
//       const servitorId = servitor.Id;
//       // Fetch accepted orders from the backend endpoint.
//       fetch(`http://localhost:4001/servitor-accepted-orders/${servitor.Id}`)
//         .then((res) => res.json())
//         .then((orderData) => {
//           // Filter orders: keep only those with status "Accepted"
//           // and where the order’s assigned Servitor's Id matches the logged-in servitor.
//           const accepted = orderData.filter(
//             (order) =>
//               // order.status === "Accepted" 
//             (order.status === "Accepted" || order.status === "In-Progress") &&
//               order.Servitor &&
//               order.Servitor.Id === servitorId
//           );
//           setAcceptedOrders(accepted);
//           setLoading(false);
//         })
//         .catch((error) => {
//           console.error("Error fetching orders:", error);
//           setLoading(false);
//         });
//     }
//   }, [servitor]);

//   const handleViewDetails = (order) => {
//     if (servitor?.approve_status === "Blocked") {
//       setBlockedModal(true);
//     } else {
//       setSelectedOrder(order);
//     }
//   };

//   const handleBackToOrders = () => {
//     setSelectedOrder(null);
//   };

//   // Pagination logic
//   const indexOfLastOrder = currentPage * ordersPerPage;
//   const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
//   const currentOrders = acceptedOrders.slice(indexOfFirstOrder, indexOfLastOrder);
//   const totalPages = Math.ceil(acceptedOrders.length / ordersPerPage);

//   // Single handler to update page number
//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   // Inline styles for the table design.
//   const tableStyle = {
//     width: "100%",
//     borderCollapse: "collapse",
//     marginBottom: "20px",
//   };

//   const thStyle = {
//     border: "1px solid #ddd",
//     padding: "8px",
//     backgroundColor: "#f2f2f2",
//     textAlign: "left",
//   };

//   const tdStyle = {
//     border: "1px solid #ddd",
//     padding: "8px",
//     textAlign: "left",
//   };

//   const buttonStyle = {
//     backgroundColor: "#10b981",
//     color: "#fff",
//     border: "none",
//     padding: "5px 10px",
//     borderRadius: "5px",
//     cursor: "pointer",
//   };

//   const formatDate = (dateStr) => new Date(dateStr).toLocaleDateString();

//   if (loading) return <p>Loading...</p>;

//   const mainContent = selectedOrder ? (
//     <ViewOrderDetails order={selectedOrder} onBack={handleBackToOrders} />
//   ) : (
//     <>
//       <h2 className="servitorsite-welcome-heading">Accepted Orders</h2>
//       {acceptedOrders.length === 0 ? (
//         <p>No accepted orders found.</p>
//       ) : (
//         <>
//           <table style={tableStyle}>
//             <thead>
//               <tr>
//                 <th style={thStyle}>Order ID</th>
//                 <th style={thStyle}>Service</th>
//                 <th style={thStyle}>Price</th>
//                 <th style={thStyle}>Date</th>
//                 <th style={thStyle}>Time</th>
//                 <th style={thStyle}>City</th>
//                 <th style={thStyle}>Address</th>
//                 <th style={thStyle}>Status</th>
//                 <th style={thStyle}>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {currentOrders.map((order, index) => (
//                 <tr key={index}>
//                   {/* <td style={tdStyle}>{order.Id}</td> */}
//                   <td style={tdStyle}>{order.order_number}</td>
//                   <td style={tdStyle}>
//                     {order.Service?.services_name || "N/A"}
//                   </td>
//                   <td style={tdStyle}>${order.price}</td>
//                   <td style={tdStyle}>{formatDate(order.date)}</td>
//                   <td style={tdStyle}>{order.time}</td>
//                   <td style={tdStyle}>
//                     {order.City || order.usercity || "Unknown"}
//                   </td>
//                   <td style={tdStyle}>
//                     {order.Address || order.useraddress || "Unknown"}
//                   </td>
//                   <td style={tdStyle}>{order.status}</td>
//                   <td style={tdStyle}>
//                     <button style={buttonStyle} onClick={() => handleViewDetails(order)}>
//                       View Details
//                     </button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//           <Pagination>
//             <Pagination.First
//               onClick={() => handlePageChange(1)}
//               disabled={currentPage === 1}
//             />
//             <Pagination.Prev
//               onClick={() => handlePageChange(currentPage - 1)}
//               disabled={currentPage === 1}
//             />
//             {[...Array(totalPages)].map((_, index) => (
//               <Pagination.Item
//                 key={index + 1}
//                 active={index + 1 === currentPage}
//                 onClick={() => handlePageChange(index + 1)}
//               >
//                 {index + 1}
//               </Pagination.Item>
//             ))}
//             <Pagination.Next
//               onClick={() => handlePageChange(currentPage + 1)}
//               disabled={currentPage === totalPages}
//             />
//             <Pagination.Last
//               onClick={() => handlePageChange(totalPages)}
//               disabled={currentPage === totalPages}
//             />
//           </Pagination>
//         </>
//       )}
//     </>
//   );

//   return (
//     <>
//       {mainContent}
//       <Modal show={blockedModal} onHide={() => setBlockedModal(false)}>
//         <Modal.Header closeButton>
//           <Modal.Title>Account Blocked</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           Your account has been{" "}
//           <span style={{ color: "red" }}>Blocked</span> due to certain issues.
//           Please contact HelpNao support for assistance.
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setBlockedModal(false)}>
//             Close
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </>
//   );
// };

// export default AcceptedOrders;


// ***** Upper code All is working fine, checked (25-6-25) ***** //

// import React, { useEffect, useState } from "react";
// import {useNavigate, useOutletContext } from "react-router-dom";
// import { Modal, Button, Pagination } from "react-bootstrap";
// import ViewOrderDetails from "./ViewOrderDetails";
// import CountdownTimer from "../../Components/CountDownTimer/CountdownTimer";
// import "./ServitorSite.css";

// const AcceptedOrders = () => {
//   const { servitor } = useOutletContext();
//   const [acceptedOrders, setAcceptedOrders] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [selectedOrder, setSelectedOrder] = useState(null);
//   const [blockedModal, setBlockedModal] = useState(false);
//   const navigate = useNavigate();
  
//   const [currentPage, setCurrentPage] = useState(1);
//   const ordersPerPage = 10;

//   useEffect(() => {
//     if (servitor && servitor.Id) {
//       fetch(`http://localhost:4001/servitor-accepted-orders/${servitor.Id}`)
//         .then((res) => res.json())
//         .then((orderData) => {
//           // Filter orders: keep only those with status "Accepted" or "In-Progress"
//           const accepted = orderData.filter(
//             (order) =>
//               (order.status === "Accepted" || order.status === "In-Progress") &&
//               order.Servitor &&
//               order.Servitor.Id === servitor.Id
//           );
//           setAcceptedOrders(accepted);
//           setLoading(false);
//         })
//         .catch((error) => {
//           console.error("Error fetching orders:", error);
//           setLoading(false);
//         });
//     }
//   }, [servitor]);

//   const handleViewDetails = (order) => {
//     if (servitor?.approve_status === "Blocked") {
//       setBlockedModal(true);
//     } else {
//       // setSelectedOrder(order);
//       navigate(`/servitor/orders/${order.order_number}`);
//     }
//   };

//   const handleBackToOrders = () => {
//     setSelectedOrder(null);
//   };

//   // Pagination logic
//   const indexOfLastOrder = currentPage * ordersPerPage;
//   const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
//   const currentOrders = acceptedOrders.slice(indexOfFirstOrder, indexOfLastOrder);
//   const totalPages = Math.ceil(acceptedOrders.length / ordersPerPage);

//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   // Inline styles for the table design.
//   // const tableStyle = {
//   //   width: "100%",
//   //   borderCollapse: "collapse",
//   //   marginBottom: "20px",
//   // };

//   // const thStyle = {
//   //   border: "1px solid #ddd",
//   //   padding: "8px",
//   //   backgroundColor: "#f2f2f2",
//   //   textAlign: "left",
//   // };

//   // const tdStyle = {
//   //   border: "1px solid #ddd",
//   //   padding: "8px",
//   //   textAlign: "left",
//   // };

//   // const buttonStyle = {
//   //   backgroundColor: "#10b981",
//   //   color: "#fff",
//   //   border: "none",
//   //   padding: "5px 10px",
//   //   borderRadius: "5px",
//   //   cursor: "pointer",
//   // };

//   const formatDate = (dateStr) => new Date(dateStr).toLocaleDateString();

//   if (loading) return <p>Loading...</p>;

//   const mainContent = selectedOrder ? (
//     <ViewOrderDetails order={selectedOrder} onBack={handleBackToOrders} />
//   ) : (
//     <>
//       <h2 className="servitorsite-welcome-heading">Accepted Orders</h2>
//       {acceptedOrders.length === 0 ? (
//         <p>No accepted orders found.</p>
//       ) : (
//         <>
//           {/* <table style={tableStyle}>
//             <thead>
//               <tr>
//                 <th style={thStyle}>Order ID</th>
//                 <th style={thStyle}>Service</th>
//                 <th style={thStyle}>Price</th>
//                 <th style={thStyle}>Date</th>
//                 <th style={thStyle}>Time</th>
//                 <th style={thStyle}>City</th>
//                 <th style={thStyle}>Address</th>
//                 <th style={thStyle}>Status</th>
//                 <th style={thStyle}>Time Left</th>
//                 <th style={thStyle}>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {currentOrders.map((order, index) => (
//                 <tr key={index}>
//                   <td style={tdStyle}>{order.order_number}</td>
//                   <td style={tdStyle}>
//                     {order.Service?.services_name || "N/A"}
//                   </td>
//                   <td style={tdStyle}>${order.price}</td>
//                   <td style={tdStyle}>{formatDate(order.date)}</td>
//                   <td style={tdStyle}>{order.time}</td>
//                   <td style={tdStyle}>{order.City || order.usercity || "Unknown"}</td>
//                   <td style={tdStyle}>{order.Address || order.useraddress || "Unknown"}</td>
//                   <td style={tdStyle}>{order.status}</td>
//                   <td style={tdStyle}>
//                     <CountdownTimer
//                       dueDate={order.deadline}
//                       status={order.status}
//                     />
//                   </td>
//                   <td style={tdStyle}>
//                     <button style={buttonStyle} onClick={() => handleViewDetails(order)}>
//                       View Details
//                     </button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table> */}

//           <div className="accepted-orders-table-wrapper">
//             <table className="accepted-orders-table">
//               <thead>
//                 <tr>
//                   <th className="accepted-orders-th">Order ID</th>
//                   <th className="accepted-orders-th">Service</th>
//                   <th className="accepted-orders-th">Price</th>
//                   <th className="accepted-orders-th">Date</th>
//                   <th className="accepted-orders-th">Time</th>
//                   <th className="accepted-orders-th">City</th>
//                   <th className="accepted-orders-th">Address</th>
//                   <th className="accepted-orders-th">Status</th>
//                   <th className="accepted-orders-th">Time Left</th>
//                   <th className="accepted-orders-th">Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {currentOrders.map((order, index) => (
//                   <tr key={index}>
//                     <td className="accepted-orders-td">{order.order_number}</td>
//                     <td className="accepted-orders-td">
//                       {order.Service?.services_name || "N/A"}
//                     </td>
//                     <td className="accepted-orders-td">{order.price} Tk</td>
//                     <td className="accepted-orders-td">{formatDate(order.date)}</td>
//                     <td className="accepted-orders-td">{order.time}</td>
//                     <td className="accepted-orders-td">
//                       {order.City || order.usercity || "Unknown"}
//                     </td>
//                     <td className="accepted-orders-td">
//                       {order.Address || order.useraddress || "Unknown"}
//                     </td>
//                     <td className="accepted-orders-td">{order.status}</td>
//                     <td className="accepted-orders-td">
//                     <div className="accepted-orders-countdown-container">
//                       <CountdownTimer
//                         dueDate={order.deadline}
//                         status={order.status}
//                       />
//                     </div>
//                     </td>
//                     <td className="accepted-orders-td">
//                       <button
//                         className="accepted-orders-btn"
//                         onClick={() => handleViewDetails(order)}
//                       >
//                         View Details
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>

//           <Pagination>
//             <Pagination.First
//               onClick={() => handlePageChange(1)}
//               disabled={currentPage === 1}
//             />
//             <Pagination.Prev
//               onClick={() => handlePageChange(currentPage - 1)}
//               disabled={currentPage === 1}
//             />
//             {[...Array(totalPages)].map((_, index) => (
//               <Pagination.Item
//                 key={index + 1}
//                 active={index + 1 === currentPage}
//                 onClick={() => handlePageChange(index + 1)}
//               >
//                 {index + 1}
//               </Pagination.Item>
//             ))}
//             <Pagination.Next
//               onClick={() => handlePageChange(currentPage + 1)}
//               disabled={currentPage === totalPages}
//             />
//             <Pagination.Last
//               onClick={() => handlePageChange(totalPages)}
//               disabled={currentPage === totalPages}
//             />
//           </Pagination>
//         </>
//       )}
//     </>
//   );

//   return (
//     <>
//       {mainContent}
//       <Modal show={blockedModal} onHide={() => setBlockedModal(false)}>
//         <Modal.Header closeButton>
//           <Modal.Title>Account Blocked</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           Your account has been{" "}
//           <span style={{ color: "red" }}>Blocked</span> due to certain issues.
//           Please contact HelpNao support for assistance.
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setBlockedModal(false)}>
//             Close
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </>
//   );
// };

// export default AcceptedOrders;


// ***** Upper code All is working fine, checked (25-6-25) ***** //








// ***** Add Translate EN BN (25-6-25) ***** //

// import React, { useEffect, useState } from "react";
// import {useNavigate, useOutletContext } from "react-router-dom";
// import { Modal, Button, Pagination } from "react-bootstrap";
// import ViewOrderDetails from "./ViewOrderDetails";
// import CountdownTimer from "../../Components/CountDownTimer/CountdownTimer";
// import { useTranslation } from "react-i18next";
// import "./ServitorSite.css";

// const AcceptedOrders = () => {
//   const { t } = useTranslation("servitor");

//   const { servitor } = useOutletContext();
//   const [acceptedOrders, setAcceptedOrders] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [selectedOrder, setSelectedOrder] = useState(null);
//   const [blockedModal, setBlockedModal] = useState(false);
//   const navigate = useNavigate();
  
//   const [currentPage, setCurrentPage] = useState(1);
//   const ordersPerPage = 10;

//   useEffect(() => {
//     if (servitor && servitor.Id) {
//       fetch(`http://localhost:4001/servitor-accepted-orders/${servitor.Id}`)
//         .then((res) => res.json())
//         .then((orderData) => {
//           // Filter orders: keep only those with status "Accepted" or "In-Progress"
//           const accepted = orderData.filter(
//             (order) =>
//               (order.status === "Accepted" || order.status === "In-Progress") &&
//               order.Servitor &&
//               order.Servitor.Id === servitor.Id
//           );
//           setAcceptedOrders(accepted);
//           setLoading(false);
//         })
//         .catch((error) => {
//           console.error("Error fetching orders:", error);
//           setLoading(false);
//         });
//     }
//   }, [servitor]);

//   const handleViewDetails = (order) => {
//     if (servitor?.approve_status === "Blocked") {
//       setBlockedModal(true);
//     } else {
//       // setSelectedOrder(order);
//       navigate(`/servitor/orders/${order.order_number}`);
//     }
//   };

//   const handleBackToOrders = () => {
//     setSelectedOrder(null);
//   };

//   // Pagination logic
//   const indexOfLastOrder = currentPage * ordersPerPage;
//   const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
//   const currentOrders = acceptedOrders.slice(indexOfFirstOrder, indexOfLastOrder);
//   const totalPages = Math.ceil(acceptedOrders.length / ordersPerPage);

//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };
//   const formatDate = (dateStr) => new Date(dateStr).toLocaleDateString();

//   // if (loading) return <p>Loading...</p>;

//   if (loading) return <p>{t("common.loading")}</p>;

//   const mainContent = selectedOrder ? (
//     <ViewOrderDetails order={selectedOrder} onBack={handleBackToOrders} />
//   ) : (
//     <>
//       {/* <h2 className="servitorsite-welcome-heading">Accepted Orders</h2> */}
//       <h2 className="servitorsite-welcome-heading">{t("acceptedOrders.heading")}</h2>
//       {acceptedOrders.length === 0 ? (
//         // <p>No accepted orders found.</p>
//         <p>{t("acceptedOrders.noOrders")}</p>
//       ) : (
//         <>
//           <div className="accepted-orders-table-wrapper">
//             <table className="accepted-orders-table">
//               <thead>
//                 <tr>
//                   {/* <th className="accepted-orders-th">Order ID</th>
//                   <th className="accepted-orders-th">Service</th>
//                   <th className="accepted-orders-th">Price</th>
//                   <th className="accepted-orders-th">Date</th>
//                   <th className="accepted-orders-th">Time</th>
//                   <th className="accepted-orders-th">City</th>
//                   <th className="accepted-orders-th">Address</th>
//                   <th className="accepted-orders-th">Status</th>
//                   <th className="accepted-orders-th">Time Left</th>
//                   <th className="accepted-orders-th">Actions</th> */}

//                   <th className="accepted-orders-th">{t("acceptedOrders.orderId")}</th> {/* NEW: Translated */}
//                   <th className="accepted-orders-th">{t("acceptedOrders.service")}</th> {/* NEW: Translated */}
//                   <th className="accepted-orders-th">{t("acceptedOrders.price")}</th> {/* NEW: Translated */}
//                   <th className="accepted-orders-th">{t("acceptedOrders.date")}</th> {/* NEW: Translated */}
//                   <th className="accepted-orders-th">{t("acceptedOrders.time")}</th> {/* NEW: Translated */}
//                   <th className="accepted-orders-th">{t("acceptedOrders.city")}</th> {/* NEW: Translated */}
//                   <th className="accepted-orders-th">{t("acceptedOrders.address")}</th> {/* NEW: Translated */}
//                   <th className="accepted-orders-th">{t("acceptedOrders.status")}</th> {/* NEW: Translated */}
//                   <th className="accepted-orders-th">{t("acceptedOrders.timeLeft")}</th> {/* NEW: Translated */}
//                   <th className="accepted-orders-th">{t("acceptedOrders.actions")}</th> {/* NEW: Translated */}

//                 </tr>
//               </thead>
//               <tbody>
//                 {currentOrders.map((order, index) => (
//                   <tr key={index}>
//                     <td className="accepted-orders-td">{order.order_number}</td>
//                     <td className="accepted-orders-td">
//                       {order.Service?.services_name || "N/A"}
//                     </td>
//                     <td className="accepted-orders-td">{order.price} Tk</td>
//                     <td className="accepted-orders-td">{formatDate(order.date)}</td>
//                     <td className="accepted-orders-td">{order.time}</td>
//                     <td className="accepted-orders-td">
//                       {order.City || order.usercity || "Unknown"}
//                     </td>
//                     <td className="accepted-orders-td">
//                       {order.Address || order.useraddress || "Unknown"}
//                     </td>
//                     <td className="accepted-orders-td">{order.status}</td>
//                     <td className="accepted-orders-td">
//                     <div className="accepted-orders-countdown-container">
//                       <CountdownTimer
//                         dueDate={order.deadline}
//                         status={order.status}
//                       />
//                     </div>
//                     </td>
//                     <td className="accepted-orders-td">
//                       <button
//                         className="accepted-orders-btn"
//                         onClick={() => handleViewDetails(order)}
//                         aria-label={t("acceptedOrders.viewDetails")}
//                       >
//                         {/* View Details */}
//                         {t("acceptedOrders.viewDetails")}
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>

//           <Pagination>
//             <Pagination.First
//               onClick={() => handlePageChange(1)}
//               disabled={currentPage === 1}
//               aria-label={t("acceptedOrders.firstPage")}
//             />
//             <Pagination.Prev
//               onClick={() => handlePageChange(currentPage - 1)}
//               disabled={currentPage === 1}
//               aria-label={t("acceptedOrders.previousPage")}
//             />
//             {[...Array(totalPages)].map((_, index) => (
//               <Pagination.Item
//                 key={index + 1}
//                 active={index + 1 === currentPage}
//                 onClick={() => handlePageChange(index + 1)}
//                 aria-label={`${t("acceptedOrders.page")} ${index + 1}`}
//               >
//                 {index + 1}
//               </Pagination.Item>
//             ))}
//             <Pagination.Next
//               onClick={() => handlePageChange(currentPage + 1)}
//               disabled={currentPage === totalPages}
//               aria-label={t("acceptedOrders.nextPage")}
//             />
//             <Pagination.Last
//               onClick={() => handlePageChange(totalPages)}
//               disabled={currentPage === totalPages}
//               aria-label={t("acceptedOrders.lastPage")}
//             />
//           </Pagination>
//         </>
//       )}
//     </>
//   );

//   return (
//     <>
//       {mainContent}
//       <Modal show={blockedModal} onHide={() => setBlockedModal(false)}>
//         <Modal.Header closeButton>
//           {/* <Modal.Title>Account Blocked</Modal.Title> */}
//           <Modal.Title>{t("acceptedOrders.blockedModalTitle")}</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           {/* Your account has been{" "}
//           <span style={{ color: "red" }}>Blocked</span> due to certain issues.
//           Please contact HelpNao support for assistance. */}

//           dangerouslySetInnerHTML={{ __html: t("acceptedOrders.blockedModalBody") }}

//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setBlockedModal(false)}>
//             {/* Close */}
//             {t("acceptedOrders.close")}
            
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </>
//   );
// };

// export default AcceptedOrders;


// ***** All checked okay (7-7-25) ***** //




// ***** New Design update (7-7-25) ***** //

import React, { useEffect, useState } from "react";
import {useNavigate, useOutletContext, useLocation } from "react-router-dom";
import { Modal, Button, Pagination } from "react-bootstrap";
// import ViewOrderDetails from "./ViewOrderDetails";
import CountdownTimer from "../../Components/CountDownTimer/CountdownTimer";
import { useTranslation } from "react-i18next";
import "./AcceptedOrdersStyle.css";
import { URL } from "../../config";
import Loader from "../../Components/LoaderSpin/Loader";

const AcceptedOrders = () => {
  const { t } = useTranslation("servitor");
  const { servitor } = useOutletContext();
  const navigate = useNavigate();

  // 🔄 NEW: Grab current ?page= value (default 1)
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const initialPage = parseInt(params.get("page") || "1", 10);
  
  // 🔄 NEW: Store pathname and search for URL updates
  const { pathname, search } = location;
  const navigateRef = React.useRef(navigate);
  
  // 🔄 CHANGE: Initialize from URL instead of always 1
  const [currentPage, setCurrentPage] = useState(initialPage);
  
  const [acceptedOrders, setAcceptedOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  // 🔄 CHANGE: Removed unused selectedOrder state
  const [blockedModal, setBlockedModal] = useState(false);
  
  const ordersPerPage = 10;
  

  useEffect(() => {
      if (servitor && servitor.Id) {
        fetch(`${URL}/servitor-accepted-orders/${servitor.Id}`)
          .then((res) => res.json())
          .then((orderData) => {
            const accepted = Array.isArray(orderData)
              ? orderData.filter(
                  (order) =>
                    (order.status === "Accepted" || order.status === "In-Progress") &&
                    order.Servitor &&
                    order.Servitor.Id === servitor.Id
                )
              : [];
            setAcceptedOrders(accepted);
            setLoading(false);
          })
          .catch(() => {
            setAcceptedOrders([]);
            setLoading(false);
          });
      }
    }, [servitor]);

 // 🔄 NEW: Update URL with current page number
   useEffect(() => {
     const params = new URLSearchParams(search);
     params.set("page", currentPage);
     navigateRef.current(
       { pathname, search: params.toString() },
       { replace: true }
     );
   }, [currentPage, pathname, search]);
 
   // 🔄 CHANGE: Pass location state to preserve ?page
   const handleViewDetails = (order) => {
     if (servitor?.approve_status === "Blocked") {
       setBlockedModal(true);
     } else {
       navigate(`/servitor/orders/${order.order_number}`, {
         state: { from: location },
       });
     }
   };


  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  // const formatDate = (dateStr) => new Date(dateStr).toLocaleDateString();
  const formatDate = (dateStr) => {
   const d = new Date(dateStr);
   const day = d.getDate();
   const month = d.toLocaleString("default", { month: "long" });
   const year = d.getFullYear();
   return `${day}-${month}-${year}`;
 };

  // 🔄 NEW: Added truncateAddress to match CompleteOrders
  const truncateAddress = (address = "", maxLength = 25) => {
    return String(address).length > maxLength
      ? String(address).substring(0, maxLength) + "..."
      : String(address);
  };

  // Pagination calculations
  const indexOfLastOrder = currentPage * ordersPerPage;
  const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
  const currentOrders = acceptedOrders.slice(indexOfFirstOrder, indexOfLastOrder);
  const totalPages = Math.ceil(acceptedOrders.length / ordersPerPage);
  const totalOrders = acceptedOrders.length;
  const startOrder = indexOfFirstOrder + 1;
  const endOrder = Math.min(indexOfLastOrder, totalOrders);

  // if (loading) return <p>Loading...</p>;

  // if (loading) return <p>{t("common.loading")}</p>;

  return (
    <div className="acceptedorders-container">
      <Loader show={loading} />
      <div className="acceptedorders-header">
        <h1 className="acceptedorders-title">{t("acceptedOrders.heading")}</h1>
      </div>

      {acceptedOrders.length === 0 ? (
        <p className="acceptedorders-empty">{t("acceptedOrders.noOrders")}</p>
      ) : (
        <>
          <div className="acceptedorders-content">
            <div className="acceptedorders-desktop">
              <div className="acceptedorders-table-wrapper">
                <table className="acceptedorders-table">
                  <thead>
                    <tr>
                      <th className="acceptedorders-th">{t("acceptedOrders.orderId")}</th>
                      <th className="acceptedorders-th">{t("acceptedOrders.service")}</th>
                      <th className="acceptedorders-th">{t("acceptedOrders.price")}</th>
                      <th className="completeorders-th">
                        {t("completeOrders.dateTime")}
                      </th>
                      <th className="completeorders-th">
                        {t("completeOrders.location")}
                      </th>
                      <th className="acceptedorders-th">{t("acceptedOrders.status")}</th>
                      <th className="acceptedorders-th">{t("acceptedOrders.timeLeft")}</th>
                      <th className="acceptedorders-th">{t("acceptedOrders.actions")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentOrders.map((order, index) => (
                      <tr key={index} className="acceptedorders-row">
                        <td className="acceptedorders-td">{order.order_number}</td>
                        <td className="acceptedorders-td">
                          {order.Service?.services_name || "N/A"}
                        </td>
                        <td className="acceptedorders-td acceptedorders-price">
                          {order.price} Tk
                        </td>
                        <td className="acceptedorders-td">
                          <div>{formatDate(order.date)}</div>
                          <div className="acceptedorders-time">{order.time}</div>
                        </td>
                        <td className="acceptedorders-td">
                          <div className="acceptedorders-city">
                            {order.City || order.usercity || "Unknown"}, {order.Area || order.userarea || "Unknown"}
                          </div>
                          <div className="acceptedorders-address">
                            {truncateAddress(order.Address || order.useraddress || "Unknown")}
                          </div>
                        </td>
                        <td className="acceptedorders-td">
                          <span className="acceptedorders-status">{order.status}</span>
                        </td>
                        <td className="acceptedorders-td">
                          <div className="acceptedorders-countdown-container">
                            <CountdownTimer dueDate={order.deadline} status={order.status} />
                          </div>
                        </td>
                        <td className="acceptedorders-td">
                          <button
                            className="acceptedorders-btn"
                            onClick={() => handleViewDetails(order)}
                            aria-label={t("acceptedOrders.viewDetails")}
                          >
                            {t("acceptedOrders.viewDetails")}
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* 🔄 NEW: Added mobile card view to match CompleteOrders */}
            <div className="acceptedorders-mobile">
              {currentOrders.map((order, index) => (
                <div key={index} className="acceptedorders-card">
                  <div className="acceptedorders-card-header">
                    <div>
                      <h3 className="acceptedorders-card-title">{order.order_number}</h3>
                      <p className="acceptedorders-card-service">
                        {order.Service?.services_name || "N/A"}
                      </p>
                    </div>
                    <div className="acceptedorders-card-right">
                      <p className="acceptedorders-card-price">{order.price} Tk</p>
                      <span className="acceptedorders-status">{order.status}</span>
                    </div>
                  </div>
                  <div className="acceptedorders-card-body">
                    <div className="acceptedorders-card-item">
                      <span className="acceptedorders-card-label">
                        {t("acceptedOrders.dateTime")}
                      </span>
                      <span className="acceptedorders-card-value">
                        {formatDate(order.date)} at {order.time}
                      </span>
                    </div>
                    <div className="acceptedorders-card-item">
                      <span className="acceptedorders-card-label">
                        {t("acceptedOrders.location")}
                      </span>
                      <div className="acceptedorders-card-value">
                        <div>{order.City || order.usercity || "Unknown"}, {order.Area || order.userarea || "Unknown"}</div>
                        <div className="acceptedorders-card-address">
                          {truncateAddress(order.Address || order.useraddress || "Unknown")}
                        </div>
                      </div>
                    </div>
                    {/* 🔄 NEW: Centered countdown timer in mobile view */}
                    <div className="acceptedorders-card-item acceptedorders-card-countdown">
                      <span className="acceptedorders-card-label">
                        {t("acceptedOrders.timeLeft")}
                      </span>
                      <div className="acceptedorders-card-value acceptedorders-countdown-container">
                        <CountdownTimer dueDate={order.deadline} status={order.status} />
                      </div>
                    </div>
                  </div>
                  <button
                    className="acceptedorders-btn"
                    onClick={() => handleViewDetails(order)}
                    aria-label={t("acceptedOrders.viewDetails")}
                  >
                    {t("acceptedOrders.viewDetails")}
                  </button>
                </div>
              ))}
            </div>
          </div>

          {/* 🔄 NEW: Added pagination summary */}
          <div className="acceptedorders-summary">
            {t("acceptedOrders.paginationSummary", {
              startOrder,
              endOrder,
              totalOrders,
            })}
          </div>

          {/* 🔄 CHANGE: Updated pagination to match CompleteOrders */}
          <div className="acceptedorders-pagination">
            <Pagination>
              <Pagination.First
                onClick={() => handlePageChange(1)}
                disabled={currentPage === 1}
                aria-label={t("acceptedOrders.firstPage")}
              />
              <Pagination.Prev
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                {t("acceptedOrders.previousPage")}
              </Pagination.Prev>
              <Pagination.Next
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                {t("acceptedOrders.nextPage")}
              </Pagination.Next>
              <Pagination.Last
                onClick={() => handlePageChange(totalPages)}
                disabled={currentPage === totalPages}
                aria-label={t("acceptedOrders.lastPage")}
              />
            </Pagination>
          </div>
        </>
      )}

      <Modal show={blockedModal} onHide={() => setBlockedModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{t("acceptedOrders.blockedModalTitle")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* 🔄 CHANGE: Fixed translation usage for blockedModalBody */}
          <div dangerouslySetInnerHTML={{ __html: t("acceptedOrders.blockedModalBody") }} />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setBlockedModal(false)}>
            {t("acceptedOrders.close")}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AcceptedOrders;